<template>
    <vue-draggable-resizable class="ql-selection-cue-marker"
        :style="{borderColor:cueColor(cue)}"
        :x="cuePosLeft" :y="cuePosTop"
        :w="cue.width || 20" :h="cue.height || 20"
        :minw="10" :minh="10"
        :parent="true"
        :draggable="editable && !locked" :resizable="editable && !locked"
        @dragging="onDrag"
        @dragstop="onDragStop" @resizestop="onResize"
        @activated="onActivate" @deactivated="onDeactivate" >
        <md-tooltip md-direction="top" v-if="!locked && editable">Move or Resize</md-tooltip>
    </vue-draggable-resizable>
</template>

<script>

import { mapGetters } from 'vuex';
import vueDragResize from 'vue-draggable-resizable';
/**
 * Component For...
 */
const CueSelectionMarker = {
    name: 'CueSelectionMarker',
    props: ['cue', 'locked', 'editable', 'pageWidth', 'pageHeight'],
    data: function() {
        return {
            dragging: false
        };
    },
    computed: {
        ...mapGetters([
            'layerByCue'
        ]),
        layer: function() {
            return this.layerByCue(this.cue);
        },
        cuePosLeft() {
            if (!this.dragging && this.cue.x <= 1) {
                return this.cue.x * this.pageWidth;
            }
            return this.cue.x;
        },
        cuePosTop() {
            if (!this.dragging && this.cue.y <= 1) {
                return this.cue.y * this.pageHeight;
            }
            return this.cue.y;
        }
    },
    methods: {
        cueColor(cue) {
            const layer = this.layerByCue(cue);
            if (layer) return layer.color;

            return 'black';
        },
        onDrag(x, y) {
            this.cue.x = x;
            this.cue.y = y;
            this.dragging = true;
        },
        onDragStop(x, y) {
            const cue = {
                ...this.cue,
                x: x,
                y: y
            };
            this.dragging = false;
            this.$emit('updateCue', cue);
        },
        onResize(x, y, width, height) {
            const cue = {
                ...this.cue,
                x: x,
                y: y,
                width: width,
                height: height
            };
            this.$emit('updateCue', cue);
        },
        onActivate() {
            this.$emit('activated');
        },
        onDeactivate() {
            this.$emit('deactivated');
        }
    },
    components: {
        'vue-draggable-resizable': vueDragResize
    },

    mounted: function() {
    }
};

export default CueSelectionMarker;
</script>

<style lang="scss">
.ql-selection-cue-marker {
    width: 10px;
    height: 10px;
    opacity: 1;
    cursor: move;
    color: black;
    pointer-events: fill;
    background-color: none;
    border: 1px solid black;
}

.ql-marker-icon {
    text-rendering: optimizeLegibility;
    vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// cue-selection-marker.vue?7aa51516